module.exports = __webpack_public_path__ + "img/goldregen-2020-005.28694853.jpg";